import { apiCall } from '../../context/api';

const toNullableAccountId = (value) => (value === '' || value == null ? null : value);

export const setChartofAcct = async (baseURL, token, formData, onSuccess, onError) => {
  const payload = {
    income: toNullableAccountId(formData.income),
    cost: toNullableAccountId(formData.cost),
    asset: toNullableAccountId(formData.asset),
  };

  try {
    await apiCall(baseURL, token, 'POST', '/core/onboarding/set-default-accounts', payload);
    onSuccess();
  } catch (error) {
    onError(error.message);
  }
};

export const fetchCoaInfo = async (baseURL, token, setAccounts, onError) => {
  try {
    const data = await apiCall(baseURL, token, 'GET', '/core/onboarding/get-mapping-info/QBO');
    setAccounts(data);
  } catch (error) {
    onError('Failed to load chart of accounts information');
  }
};
